// extracted by mini-css-extract-plugin
module.exports = {"edit":"XPclqFizZ0LE87l6BTRhI"};